import React from "react";

export function LoginActivity() {
    return (
        <div>

        </div>
    )
}